export const ITR_updateCurrentScreenReducer = {
  ITR_updateCurrentScreen: (state, action) => {
    state.currentScreen = action.payload;
  },
};
